import { Carousel, Grid, List } from '@lightningjs/ui';

const setItemsIndexHelper = (
  items: unknown,
  customHandler?: (item: any, index: number) => void,
) => {
  if (Array.isArray(items)) {
    items.forEach((item, index) => {
      if (typeof item === 'object' && item) {
        item.itemIndex = index;
        customHandler?.(item, index);
      }
    });
  }
};

export class ListWithIndexing extends List {
  get items() {
    return super.items;
  }

  set items(items: any) {
    setItemsIndexHelper(items);
    super.items = items;
  }

  override add(item: any) {
    const addedItem = super.add(item);
    setItemsIndexHelper(this.items);
    return addedItem;
  }

  setItemsIndex() {
    const updateLaneIndex = (item: any, index: number) => {
      if (item.laneIndex !== undefined) item.laneIndex = index;
    };

    setItemsIndexHelper(this.items, updateLaneIndex);
  }
}

export class CarouselWithIndexing extends Carousel {
  get items() {
    return super.items;
  }

  set items(items: any) {
    setItemsIndexHelper(items);
    super.items = items;
  }

  override add(item: any) {
    const addedItem = super.add(item);
    setItemsIndexHelper(this.items);
    return addedItem;
  }
}

export class GridWithIndexing extends Grid {
  get items() {
    return super.items;
  }

  set items(items: any) {
    setItemsIndexHelper(items);
    super.items = items;
  }

  override add(item: any) {
    const addedItem = super.add(item);
    setItemsIndexHelper(this.items);
    return addedItem;
  }
}
